module.exports = __webpack_public_path__ + "img/terrain-tool.cc4b6381.png";